import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useTheme } from '@web-chat-core/ui-kit';
import ModalOverlay from '@web-chat-core/ui-kit/core/ModalOverlay';
import { ModalName } from 'features/Modals/ModalProvider';
import { selectIsModalOpened, selectParticipantsLimitModalData } from 'state/selectors';
import {
    Logo,
    ParticipantsLimitErrorAction,
    ParticipantsLimitErrorActions,
    ParticipantsLimitErrorDescription,
    ParticipantsLimitErrorLogo,
    ParticipantsLimitErrorModalBody,
    ParticipantsLimitErrorModalContent,
    ParticipantsLimitErrorSecondaryAction,
    ParticipantsLimitErrorTitle,
} from './view';

export const ParticipantsLimitModal = observer(() => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isOpen = selectIsModalOpened(ModalName.PARTICIPANTS_LIMIT);
    const data = selectParticipantsLimitModalData();

    const isRetryLoading = data?.isRetryLoading ?? false;
    const onRetry = data?.onRetry;
    const onClose = data?.onClose;

    if (!isOpen || !onRetry || !onClose) {
        return null;
    }

    return (
        <ModalOverlay
            name="participants-limit-modal"
            onClick={onClose}
            isNeedOverlay={true}
            overlayBackground={theme.root.colors.background['01Base']}
        >
            <ParticipantsLimitErrorModalBody onClick={(event: React.MouseEvent) => event.stopPropagation()}>
                <ParticipantsLimitErrorModalContent>
                    <ParticipantsLimitErrorLogo>
                        <Logo src={theme.logo.withText} draggable="false" />
                    </ParticipantsLimitErrorLogo>
                    <ParticipantsLimitErrorTitle variant="title6">
                        {t('vks_call_access_limit_reached_title')}
                    </ParticipantsLimitErrorTitle>
                    <ParticipantsLimitErrorDescription variant="title8">
                        {t('vks_access_limit_reached_message')}
                    </ParticipantsLimitErrorDescription>
                    <ParticipantsLimitErrorActions>
                        <ParticipantsLimitErrorSecondaryAction loading={isRetryLoading} onClick={onRetry}>
                            {t('vks_access_limit_reached_retry')}
                        </ParticipantsLimitErrorSecondaryAction>
                        <ParticipantsLimitErrorAction onClick={onClose}>
                            {t('web_calls_cancel_share_screen')}
                        </ParticipantsLimitErrorAction>
                    </ParticipantsLimitErrorActions>
                </ParticipantsLimitErrorModalContent>
            </ParticipantsLimitErrorModalBody>
        </ModalOverlay>
    );
});
